interface SeatMapProps {
  activeZone: string | null;
  onZoneHover: (zone: string | null) => void;
}

export default function SeatMap({ activeZone, onZoneHover }: SeatMapProps) {
  return (
    <div className="flex flex-col items-center w-full select-none">
      {/* PALCO button */}
      <div className="mb-4">
        <button className="border border-gray-400 text-gray-700 text-xs font-semibold px-6 py-1 bg-white cursor-pointer whitespace-nowrap">
          PALCO
        </button>
      </div>

      {/* Seat zones grid */}
      <div className="grid grid-cols-2 gap-2 w-full max-w-[340px]">
        {/* Top-left: Plateia */}
        <div
          className={`h-[100px] cursor-pointer transition-opacity ${activeZone === "Plateia" ? "opacity-75" : "opacity-100"}`}
          style={{ backgroundColor: "#7dc232" }}
          onMouseEnter={() => onZoneHover("Plateia")}
          onMouseLeave={() => onZoneHover(null)}
        />

        {/* Top-right: Mobilidade Condicionada */}
        <div
          className={`h-[100px] cursor-pointer relative transition-opacity ${activeZone === "Mobilidade Condicionada" ? "opacity-75" : "opacity-100"}`}
          style={{ backgroundColor: "#7dc232" }}
          onMouseEnter={() => onZoneHover("Mobilidade Condicionada")}
          onMouseLeave={() => onZoneHover(null)}
        >
          <div className="absolute top-1 right-1 w-6 h-6 flex items-center justify-center">
            <i className="ri-user-line text-white text-base" style={{ filter: "drop-shadow(0 0 1px rgba(0,0,0,0.5))" }}></i>
          </div>
        </div>

        {/* Bottom-left: Plateia (lower section) */}
        <div
          className={`h-[100px] cursor-pointer transition-opacity ${activeZone === "Plateia" ? "opacity-75" : "opacity-100"}`}
          style={{ backgroundColor: "#7dc232" }}
          onMouseEnter={() => onZoneHover("Plateia")}
          onMouseLeave={() => onZoneHover(null)}
        />

        {/* Bottom-right: VIP */}
        <div
          className={`h-[100px] cursor-pointer relative transition-opacity ${activeZone === "VIP" ? "opacity-75" : "opacity-100"}`}
          style={{ backgroundColor: "#7dc232" }}
          onMouseEnter={() => onZoneHover("VIP")}
          onMouseLeave={() => onZoneHover(null)}
        >
          <div className="absolute top-1 right-1 w-6 h-6 flex items-center justify-center">
            <i className="ri-user-line text-white text-base" style={{ filter: "drop-shadow(0 0 1px rgba(0,0,0,0.5))" }}></i>
          </div>
        </div>
      </div>
    </div>
  );
}
